import { object as objectUtil } from "./object/"
import { array as arrayUtil } from "./array/";
import { file as fileUtil } from "./file/";
import { blob as blobUtil } from "./blob/";
import { image as imageUtil } from "./image/";
import { number as numberUtil } from "./number/";


export namespace util {
    // todo: 这里 tsconfig 如何处理 util 为{}空对象
    export const object = objectUtil;
    export const array = arrayUtil;
    export const file = fileUtil;
    export const blob = blobUtil;
    export const image = imageUtil;
    export const number = numberUtil;
}
